import React from 'react';
import { BookOpen, CheckSquare, Clock, Book, Image as ImageIcon } from 'lucide-react';
import { InlineCTA } from './InlineCTA';
export function WhatYouGetSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-[#4A6741]" data-id="element-167" />,
    title: 'Guía Digital Protocolo SOS',
    desc: 'Qué hacer antes, durante y después de una crisis.'
  }, {
    icon: <CheckSquare className="w-6 h-6 text-[#4A6741]" data-id="element-168" />,
    title: 'Checklist de Mochila Sensorial',
    desc: 'Los esenciales para prevenir y responder en salidas.'
  }, {
    icon: <Clock className="w-6 h-6 text-[#4A6741]" data-id="element-169" />,
    title: 'Plan de Acción de 60 Segundos',
    desc: 'Qué hacer apenas empieza el descontrol.'
  }, {
    icon: <Book className="w-6 h-6 text-[#4A6741]" data-id="element-170" />,
    title: 'Diario de Disparadores',
    desc: 'Para detectar patrones y anticiparte.'
  }, {
    icon: <ImageIcon className="w-6 h-6 text-[#4A6741]" data-id="element-171" />,
    title: 'Tarjeta Visual Imprimible',
    desc: 'Apoyo simple para comunicación y transición.'
  }];
  return <section className="bg-[#FDF8F0] pt-14 pb-4 md:py-24 px-5" data-id="element-172">
      <div className="max-w-5xl mx-auto" data-id="element-173">
        <div className="text-center mb-10" data-id="element-174">
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D1F0E] mb-4" data-id="element-175">
            Todo lo que necesitas para dejar de improvisar en cada crisis
          </h2>
          <p className="text-base md:text-xl text-[#6B5D4F]" data-id="element-176">
            Herramientas prácticas, rápidas y fáciles de usar en casa o en
            público.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-177">
          {items.map((item, idx) => <div key={idx} className={`bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-[#D4A853]/20 flex flex-col items-start ${idx === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-178">
              <div className="w-10 h-10 bg-[#F0F4EC] rounded-xl flex items-center justify-center mb-4" data-id="element-179">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-[#2D1F0E] mb-2" data-id="element-180">
                {item.title}
              </h3>
              <p className="text-[#6B5D4F] text-sm md:text-base leading-relaxed" data-id="element-181">
                {item.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-4 md:mt-8" data-id="element-182">
          <InlineCTA text="Quiero el Protocolo SOS" data-id="element-183" />
        </div>
      </div>
    </section>;
}